import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/tailwind.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/css/index.css'

// 1. Import our new interceptor setup function
// (Please double-check that this path matches where you saved the file!)
import { setupTokenInterceptor } from '@/utils/User-taskcheck.js' 

AOS.init({
  // 可选配置（比如动画时长、延迟等）
  duration: 1000, // 动画持续时间（毫秒）
})

// 2. Initialize the interceptor so it starts watching all Axios requests globally
setupTokenInterceptor()

createApp(App).use(store).use(router).mount('#app')